import qs from 'qs';

export function getUrl(
    input: string,
    queryParams: Record<string, unknown> = {},
): string {
    const url = new URL(input, window.location.origin);

    url.search = qs.stringify(queryParams);

    return url.toString();
}
